
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useOnboardingContext } from '@/context/OnboardingContext';

const ResetOnboarding = () => {
  const navigate = useNavigate();
  const { resetOnboarding } = useOnboardingContext();

  // Check if we're in production - this button will only show in development
  const isDevelopment = process.env.NODE_ENV === 'development';

  // If we're in production, don't render the button
  if (!isDevelopment) {
    return null;
  }

  const handleReset = () => {
    resetOnboarding();
    console.log("Configuration réinitialisée - redirection vers l'onboarding");
    
    // Navigate to onboarding page
    setTimeout(() => {
      navigate('/onboarding');
    }, 1000);
  };

  return (
    <Button 
      variant="outline" 
      onClick={handleReset}
      className="mt-4 bg-red-50 hover:bg-red-100 text-red-600 border-red-200"
    >
      Réinitialiser la configuration
    </Button>
  );
};

export default ResetOnboarding;
